function hashCode(str) { // java String#hashCode
	let hash = 0;
	for (let i = 0; i < str.length; i += 1) {
		hash = str.charCodeAt(i) + ((hash << 5) - hash);
	}
	return hash;
}

function sleep(duration) {
	return new Promise((resolve) => {
		setTimeout(() => { resolve(0); }, duration);
	});
}

function intToRGB(i) {
	const c = (i & 0x00FFFFFF)
		.toString(16)
		.toUpperCase();

	return '00000'.substring(0, 6 - c.length) + c;
}

function str2Color(str) {
	return `#${intToRGB(hashCode(str.toString()))}`;
}

function randColor() {
	const colors = ['#FCAA67', '#B0413E', '#FFFFC7', '#548687', '#473335', '#5603AD', '#8367C7', '#B3E9C7'];
	const i = Math.floor(Math.random() * colors.length);
	return colors[i];
}

function generateUnit(key) {
	if (key.endsWith('人次')) return '人次';
	if (key.endsWith('金額')) return '元';
	if (key.endsWith('收入')) return '元';
	if (key.endsWith('活動數')) return '件';
	if (key.endsWith('冊數')) return '冊';
	if (key.endsWith('人數')) return '人';
	if (key.endsWith('個數')) return '個';
	if (key.endsWith('團數')) return '團';
	if (key.endsWith('收件數')) return '件';
	if (key.endsWith('收件案數')) return '案';
	if (key.endsWith('計劃數')) return '件';
	if (key.endsWith('計畫數')) return '件';
	if (key.endsWith('巡迴點數量')) return '處';
	if (key.endsWith('空間數量')) return '處';
	if (key.endsWith('典藏數')) return '件';
	if (key.endsWith('案數')) return '案';
	if (key.endsWith('總藏數')) return '件'; // A315
	if (key.endsWith('館藏數')) return '件'; // A315
	if (key.endsWith('數量')) return '件';
	if (key.includes('人次')) return '人次';
	if (key.includes('經費')) return '元';
	if (key.includes('組數')) return '組';
	if (key.includes('預算')) return '元';
	if (key.endsWith('場數')) return '場';
	if (key.endsWith('件數')) return '件';
	if (key.endsWith('藏量')) return '冊';
	if (key.endsWith('年增率')) return '%';
	if (key.endsWith('漂書點')) return '處';
	if (key.endsWith('漂書量')) return '冊';
	if (key.endsWith('漂書館')) return '館';
	if (key.endsWith('館數')) return '館';
	if (key.endsWith('件數')) return '件';
	if (key.endsWith('種類數')) return '種';
	if (key.endsWith('份數')) return '份';
	if (key.endsWith('種數')) return '種';
	if (key.endsWith('件數')) return '件';
	if (key.endsWith('藏數')) return '冊';
	if (key.endsWith('款')) return '元';
	if (key.endsWith('人口數')) return '人';
	if (key.endsWith('額')) return '元';
	if (key.includes('袋')) return '袋';
	if (key.endsWith('場次')) return '場';
	if (key.endsWith('申辦數')) return '人';
	return '';
}

function bigNum2Chinese(v) {
	if (v >= 100_000_000) {
		return `${Math.round((v / 100_000_000) * 10) / 10} 億`;
	}
	if (v >= 10_000_000) {
		return `${Math.round((v / 10_000_000) * 10) / 10} 千萬`;
	}
	if (v >= 1_000_000) {
		return `${Math.round((v / 1_000_000) * 10) / 10} 百萬`;
	}
	if (v >= 1_0000) {
		return `${Math.round((v / 1_0000) * 10) / 10} 萬`;
	}
	return v;
}

export {
	hashCode,
	sleep,
	intToRGB,
	str2Color,
	randColor,
	generateUnit,
	bigNum2Chinese,
};
